import { getPluginState } from '../pm-plugins/plugin-factory';
import { splitCellWithType } from 'prosemirror-tables';
/**
 * We need to split cell keeping the right type of cell given current table configuration.
 * We are using prosemirror-tables splitCellWithType that allows you to choose what cell type should be.
 */
export var splitCell = function (state, dispatch) {
    var tableState = getPluginState(state);
    var _a = state.schema.nodes, tableHeader = _a.tableHeader, tableCell = _a.tableCell;
    return splitCellWithType(function (_a) {
        var row = _a.row, col = _a.col;
        if ((row === 0 && tableState.isHeaderRowEnabled) ||
            (col === 0 && tableState.isHeaderColumnEnabled)) {
            return tableHeader;
        }
        return tableCell;
    })(state, dispatch);
};
//# sourceMappingURL=split-cell.js.map